import clsx from 'clsx';

import { ShiftDataEntry } from '../types/types';
import { TimeEntryTypePill } from './TimeEntryTypePill';

type TimesheetShiftEntryRowProps = {
  timeEntry: ShiftDataEntry;
  isLastShift?: boolean;
};

export function TimesheetShiftEntryRow({ timeEntry, isLastShift = false }: Readonly<TimesheetShiftEntryRowProps>) {
  // Determine which row is the last one for this shift entry
  const hasNotes = !!timeEntry.notes;
  const hasNextDay = timeEntry.isNextDayEnding;
  // Only add border-bottom to the last row of this shift entry if there's another shift after it
  const lastRowBorderClass = !isLastShift ? 'border-b border-outline-l1' : '';

  return (
    <>
      <tr className={clsx('items-center border-collapse', !hasNotes && !hasNextDay && lastRowBorderClass)}>
        <td className="py-12 px-16 text-left">
          <p className="text-18">
            {`${timeEntry.startTime} - ${timeEntry.endTime}`}
            {timeEntry.isNextDayEnding && <span className="align-super text-12">+1</span>}
          </p>
        </td>
        <td className="py-12 pr-16 text-left">
          <TimeEntryTypePill type={timeEntry.type} />
        </td>
        <td className="py-12 pr-16 text-right">
          <span className="text-18">{timeEntry.breakDuration}</span>
        </td>
        <td className="py-12 pr-16 text-right">
          <span className="text-18">{timeEntry.totalDuration}</span>
        </td>
      </tr>
      {timeEntry.isNextDayEnding && (
        <tr className={clsx(!hasNotes && lastRowBorderClass)}>
          <td colSpan={4} className={clsx('px-16', 'pb-12', 'text-left', 'text-on-surface')}>
            <span className="text-14">+1: End time extends past midnight into the next day.</span>
          </td>
        </tr>
      )}
      {!!timeEntry.notes && (
        <tr className={clsx(lastRowBorderClass)}>
          <td colSpan={4} className="pb-12 px-16 text-left">
            <p className="text-base break-all">Note: {timeEntry.notes}</p>
          </td>
        </tr>
      )}
    </>
  );
}
